import { z } from 'zod';

export const SelectTenantSchema = z.object({
  tenantId: z.string().min(1, 'Please select a tenant'),
});

export type SelectTenantFormValues = z.infer<typeof SelectTenantSchema>;
